import { Route, Switch } from "react-router-dom";

import aboutNps from "./aboutNps";
import TncAditya from "./adityatnc";
import distributeNps from "./DistributeNps";
import EmpanelementSummary from "./empanelementSummary";
import TncHdfc from "./hdfctnc";
import TncIcici from "./icicitnc";
import mis from "./mis";
import MisReports from "./MisReports";
import NewSubscriberRouter from "./newSubscriber/Router";
import SubscriberList from "./newSubscriber/SubscriberList";
import NpsBankDetails from "./NpsBankDetails";
import NpsBasicDetails from "./NpsBasicDetails";
import onlineEmpanelementStatus from "./onlineEmpanelementStatus";
import onlineEmpanelementupload from "./onlineEmpanelementupload";
import NewSubscriberProvider from "./newSubscriber/NewSubscriber";
import Additionalpurchase from "./newSubscriber/Additionalpurchase";
import Portfolio from "./newSubscriber/Portfolio";

function NewSubscriber(props) {
  return (
    <NewSubscriberProvider {...props}>
      <NewSubscriberRouter {...props} />
    </NewSubscriberProvider>
  );
}
export default function Router(props) {
  const { match } = props;
  const { path } = match;
  return (
    <Switch>
      <Route path={`${path}`} exact component={aboutNps} />
      <Route
        path={`${path}/onlineEmpanelement/basicDetails`}
        exact
        component={NpsBasicDetails}
      />
      <Route
        path={`${path}/onlineEmpanelement/bankDetails`}
        exact
        component={NpsBankDetails}
      />
      <Route
        path={`${path}/onlineEmpanelement/upload`}
        exact
        component={onlineEmpanelementupload}
      />
      <Route
        path={`${path}/onlineEmpanelement/status`}
        exact
        component={onlineEmpanelementStatus}
      />
      <Route
        path={`${path}/onlineEmpanelement/summary`}
        exact
        component={EmpanelementSummary}
      />
      <Route path={`${path}/tnc/icici`} exact component={TncIcici} />
      <Route path={`${path}/tnc/aditya`} exact component={TncAditya} />
      <Route path={`${path}/tnc/hdfc`} exact component={TncHdfc} />
      <Route path={`${path}/distributeNps`} exact component={distributeNps} />
      <Route path={`${path}/mis`} exact component={mis} />
      <Route path={`${path}/mis/reports`} exact component={MisReports} />
      <Route path={`${path}/AddSubs`} component={NewSubscriber} />
      <Route path={`${path}/subscriberslist`} component={SubscriberList} />
      <Route
        path={`${path}/additionalPurchase`}
        component={Additionalpurchase}
      />
      <Route path={`${path}/portfolio`} component={Portfolio} />
    </Switch>
  );
}
